module.exports = __webpack_public_path__ + "img/nsw_logo_full_color.3f709ecb.png";